
import { Base } from '../base-component';

import PictureFill = require('picturefill');

import './responsive-image.component.scss';

export class ResponsiveImage extends Base {

	constructor(element: Element){

		super(element);		
		
	}

	init(){

		PictureFill();

	}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/responsive-image/responsive-image.component.ts